import { render, staticRenderFns } from "./NEANDERTHAL.vue?vue&type=template&id=65e0ad6d&"
import script from "./NEANDERTHAL.vue?vue&type=script&lang=js&"
export * from "./NEANDERTHAL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports